/**
 * Google OAuth client configuration boundary.
 *
 * CRA substitutes `process.env.REACT_APP_GOOGLE_CLIENT_ID` at build time.
 * Missing, empty, or whitespace-only values disable Google OAuth.
 * There is no committed fallback client id.
 */

export function normalizeGoogleOAuthClientId(rawValue) {
  if (rawValue === undefined || rawValue === null) {
    return '';
  }
  return String(rawValue).trim();
}

export function resolveGoogleOAuthConfig(rawValue) {
  const clientId = normalizeGoogleOAuthClientId(rawValue);
  return {
    clientId,
    enabled: Boolean(clientId),
  };
}

const BUILD_TIME_GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const resolvedGoogleOAuthConfig = resolveGoogleOAuthConfig(
  BUILD_TIME_GOOGLE_OAUTH_CLIENT_ID,
);

export const GOOGLE_OAUTH_CLIENT_ID = resolvedGoogleOAuthConfig.clientId;
export const GOOGLE_OAUTH_ENABLED = resolvedGoogleOAuthConfig.enabled;
